var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYouxiang(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3a.5.5 0 01.5-.5h12a.5.5 0 01.5.5v10a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5V3z",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3l5.556 3.704a.8.8 0 00.888 0L14 3",
    stroke: "#3F465C"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNSAzQzEuNSAyLjcyMzg2IDEuNzIzODYgMi41IDIgMi41SDE0QzE0LjI3NjEgMi41IDE0LjUgMi43MjM4NiAxNC41IDNWMTNDMTQuNSAxMy4yNzYxIDE0LjI3NjEgMTMuNSAxNCAxMy41SDJDMS43MjM4NiAxMy41IDEuNSAxMy4yNzYxIDEuNSAxM1YzWiIgc3Ryb2tlPSIjM0Y0NjVDIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTIgM0w3LjU1NjI0IDYuNzA0MTZDNy44MjQ5NiA2Ljg4MzMxIDguMTc1MDQgNi44ODMzMSA4LjQ0Mzc2IDYuNzA0MTZMMTQgMyIgc3Ryb2tlPSIjM0Y0NjVDIi8+Cjwvc3ZnPgo=";
export { SvgTongyongYouxiang as ReactComponent };